module.exports = __webpack_public_path__ + "static/media/sports_1.19f4825f.jpg";